(() => {
  if (window.culturesSignatureReady) return;
  window.culturesSignatureReady = true;
  const isEnglish = () => document.documentElement.lang.toLowerCase().startsWith('en');
  const motionReduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-cs-range]')) return;
    const input = event.target;
    input.closest('[data-cs-compare]').style.setProperty('--cs-split', `${input.value}%`);
    input.setAttribute('aria-valuetext', `${100 - Number(input.value)}% ${isEnglish() ? 'of the decorated wall visible' : 'du mur décoré visible'}`);
  });
  document.addEventListener('click', (event) => {
    const pause = event.target.closest('[data-cs-pause]');
    if (pause) {
      const paused = pause.closest('[data-cs-marquee]').classList.toggle('is-paused');
      pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? (isEnglish() ? 'Resume the banner' : 'Relancer le bandeau') : (isEnglish() ? 'Pause the banner' : 'Mettre le bandeau en pause'));
      pause.querySelector('span').textContent = paused ? '>' : 'II';
    }
    const format = event.target.closest('[data-cs-format]');
    if (format) {
      const root = format.closest('[data-cs-feature]');
      root.querySelectorAll('[data-cs-format]').forEach(button => button.setAttribute('aria-pressed', String(button === format)));
      root.querySelector('[data-cs-price]').textContent = format.dataset.price;
      root.querySelector('[data-cs-dimensions]').textContent = format.dataset.dimensions;
      root.querySelector('[data-cs-feature-link]').href = format.dataset.url;
    }
    const tab = event.target.closest('[data-cs-nfc-tab]');
    if (tab) {
      const root = tab.closest('[data-cs-nfc]');
      const mode = tab.dataset.csNfcTab;
      clearTimeout(root.scanTimer);
      root.querySelectorAll('[data-cs-nfc-tab]').forEach(button => button.setAttribute('aria-pressed', String(button === tab)));
      ['csNfcCopy', 'csNfcArt', 'csPhone'].forEach(key => {
        const attribute = key.replace(/[A-Z]/g, character => `-${character.toLowerCase()}`);
        root.querySelectorAll(`[data-${attribute}]`).forEach(panel => { panel.hidden = panel.dataset[key] !== mode; });
      });
      const stage = root.querySelector('[data-cs-stage]');
      stage.classList.remove('is-scanning');
      stage.classList.toggle('is-music', mode === 'music');
      root.querySelector('[data-cs-nfc-step]').textContent = mode === 'music' ? (isEnglish() ? 'The album page opens so you can press play.' : 'La page de l’album s’ouvre pour lancer l’écoute.') : (isEnglish() ? "Lewis's mini site comes to life." : 'Le mini-site de Lewis prend vie.');
      root.querySelector('[data-cs-status]').textContent = mode === 'music' ? (isEnglish() ? "The frame opens Drake's album link." : 'Le cadre ouvre le lien vers l’album de Drake.') : (isEnglish() ? 'A preview of what opens after the scan.' : 'Un aperçu de ce qui s’ouvre après le scan.');
    }
    const scan = event.target.closest('[data-cs-scan]');
    if (scan) {
      const root = scan.closest('[data-cs-nfc]');
      const stage = root.querySelector('[data-cs-stage]');
      clearTimeout(root.scanTimer);
      stage.classList.remove('is-scanning');
      void stage.offsetWidth;
      stage.classList.add('is-scanning');
      root.querySelector('[data-cs-status]').textContent = (isEnglish() ? 'NFC notification opened…' : 'Notification NFC ouverte…');
      if (window.innerWidth < 750) stage.scrollIntoView({ behavior: motionReduced() ? 'instant' : 'smooth', block: 'center' });
      root.scanTimer = setTimeout(() => {
        stage.classList.remove('is-scanning');
        root.querySelector('[data-cs-status]').textContent = stage.classList.contains('is-music') ? (isEnglish() ? 'Album opened. Press “Listen to the album” to continue.' : 'Album ouvert. Appuie sur « Écouter l’album » pour continuer.') : (isEnglish() ? 'Experience opened. Press “Open the experience” to explore Lewis.' : 'Expérience ouverte. Appuie sur « Ouvrir l’expérience » pour explorer Lewis.');
      }, motionReduced() ? 50 : 1700);
    }
  });
})();
